import Icon from '../components/Icon.vue'

Icon.register({
  flask: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M437.2 403.5L320 215V64H328C341.3 64 352 53.3 352 40V24C352 10.7 341.3 0 328 0H120C106.7 0 96 10.7 96 24V40C96 53.3 106.7 64 120 64H128V215L10.8 403.5C-18.5 450.6 15.3 512 70.9 512H377.1C432.8 512 466.5 450.5 437.2 403.5zM137.9 320L186.1 242.4C189.8 237.2 191.9 230.8 191.9 224V64H255.9V224C255.9 230.9 258.1 237.2 261.7 242.4L309.9 320H137.9z'
      }
    ]
  }
})
